<template>
    <div>
        <app-header></app-header>
        <div class="container">

            <!-- more like reviewable container, looping stops error before reviewable has loaded -->
            <div class="column"
                v-for="scene in scenes"
                v-bind:key="scene.id"
            >

                <!-- buefy table -->
                <b-table
                    :per-page="perPage"
                    :current-page.sync="page"
                    :loading="loading"
                    
                    :focusable=false
                    :striped=true

                    :data="scenes"
                    :paginated="isPaginated"
                    backend-pagination
                    :total="total"

                    @page-change="onPageChange"

                    backend-sorting
                    :default-sort-direction="defaultSortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"
                    scrollable
                >
                    <template slot-scope="props">
                        <b-table-column field="name" label="Name" sortable>
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column field="project" label="Project" sortable>
                            <a @click="UpdateQuery('project', props.row.project)">{{ props.row.project }} </a>
                            <b-icon
                                icon="filter-outline"
                                size="is-small">
                            </b-icon>
                        </b-table-column>

                        <b-table-column field="shot" label="Shot" sortable>
                            <a @click="UpdateQuery('shot', props.row.shot)">{{ props.row.shot }} </a>
                            <b-icon
                                icon="filter-outline"
                                size="is-small">
                            </b-icon>
                        </b-table-column>

                        <b-table-column field="version" label="Version" sortable>
                            {{ props.row.version }}
                        </b-table-column>

                        <b-table-column field="action" label="Action" sortable>
                            <a @click="UpdateQuery('action', props.row.action)">{{ props.row.action }} </a>
                            <b-icon
                                icon="filter-outline"
                                size="is-small">
                            </b-icon>
                        </b-table-column>

                        <b-table-column field="notes" label="Notes" sortable>
                            {{ props.row.notes }}
                        </b-table-column>

                        <b-table-column field="user" label="User" sortable>
                            <a @click="UpdateQuery('user', props.row.user)">{{ props.row.user }} </a>
                            <b-icon
                                icon="filter-outline"
                                size="is-small">
                            </b-icon>

                        </b-table-column>

                        <b-table-column field="date_modified" label="Date Modified" sortable>
                            {{ props.row.date_modified | relative_datetime }}
                        </b-table-column>

                        <b-table-column field="date_created" label="Date Created" sortable>
                            {{ props.row.date_created | relative_datetime }}
                        </b-table-column>

                        <b-table-column field="dependencies" label="Dependencies">
                            
                            <div v-if="dependencies_scenes" v-for="scene in dependencies_scenes">
                                <router-link :to="{ name: 'scene', params: {id: scene.id} }">
                                    <b-tag type="is-primary" class="dep-tag">{{ scene.name }}</b-tag>
                                </router-link>
                            </div>

                            <div v-if="dependencies_reviewables" v-for="rev in dependencies_reviewables">
                                <router-link :to="{ name: 'single', params: {id: rev.id} }">
                                    <b-tag class="dep-tag">{{ rev.name }}</b-tag>
                                </router-link>
                            </div>

                        </b-table-column>

                        <b-table-column field="path" label="Path" sortable>
                            {{ props.row.path }}
                        </b-table-column>
                        
                    </template>
                </b-table>
                
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'
    import { date_filters } from '../mixins/Filters'

    export default {
        mixins: [GetAxiosAuthConfig, date_filters],
        data() {
            return {
                // Set data property from the router (routes.js)
                id: this.$route.params.id,

                // Data properties for the den api
                scenes : Array,

                dependencies_scenes: false,
                dependencies_reviewables: false,
            }
        },
        watch: {
            '$route'(to, from){
                // update id
                this.id = to.params.id
                
                // need to get that id!
                this.GetSingleReviewable()
            }
        },
        methods: {
            GetSingleReviewable() {
                // Use the URL rather than the filter for ID
                let resturl = window.location.origin + '/api/scenes/' + this.id + '/?format=json'

                axios
                    .get(resturl, axios_auth_config)
                    .then(response => {
                        // Does not return an array, so need to make it one to fit ol table style
                        this.scenes = [response.data]
                     }) 
                    .catch(error => console.log(error))
            },
            GetDependencies() {
                // instead of using the field on the reviewable, use the API endpoint
                let resturl = window.location.origin + '/api/scenes/' + this.id + '/dependencies/'
                console.log(resturl)
                axios.get(resturl, axios_auth_config)
                    .then(response => {
                        console.log(response.data)
                        this.dependencies_scenes = response.data.scenes
                        this.dependencies_reviewables = response.data.reviewables
                    })
                    .catch(error => console.error("get next page url error", error))
            },
        },
        mounted() {
            this.GetSingleReviewable()
            this.GetDependencies()
        },
    }
</script>

<style scoped lang="scss">
    @import "../styles/_variables.scss";
    .dep-tag {
        margin: .2em;
    }
</style>
